import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatStepper, MAT_DIALOG_DATA } from '@angular/material';
import { StudentProfileModalComponent } from 'src/app/tutorials/student-profile-modal/student-profile-modal.component';
import { ContractProvider } from 'src/app/providers/contracts/contracts.prov';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sign-contract-modal',
  templateUrl: './sign-contract-modal.component.html',
  styleUrls: ['./sign-contract-modal.component.scss']
})
export class SignContractModalComponent implements OnInit {
  @ViewChild('stepper') stepperComponent: MatStepper;
  SteepOneCompleted: boolean;
  SteepTwoCompleted: boolean;
  currentDate: Date;
  currentMonth: String;
  nameStudent = "";
  controlNumber = "";
  studentId = "";
  career = "";
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<StudentProfileModalComponent>,
    private contractProv: ContractProvider,
  ) { 
    this.currentDate = new Date();
    this.convertNumericalMonth();
    this.nameStudent = data.student.user.name.fullName;
    this.controlNumber = data.student.user.email;
    this.career = data.student.user.career;
    this.studentId = data.student.user._id;
  }

  ngOnInit() {

  }

  onClose() {
    this.dialogRef.close({ action: 'close' });
  }

  Next(index: number): void {
    switch (index) {
      case 0:
        {
          this.SteepOneCompleted = true;
          this.updateSteeps(1);
          break;
        }
      case 1: {
        this.SteepTwoCompleted = true;
        this.updateSteeps(2);
        break;
      }
    }
  }

  Back(index: number): void {
    switch (index) {
      case 1: {
        this.updateSteeps(0);
        this.SteepOneCompleted = false;
        break;
      }
      case 2: {
        this.updateSteeps(1);
        this.SteepTwoCompleted = false;
        break;
      }
    }
  }

  async updateSteeps(index: number) {
    await this.delay(150);
    this.stepperComponent.selectedIndex = index;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  convertNumericalMonth() {
    switch (this.currentDate.getMonth()) {
      case 0: {
        this.currentMonth = "Enero";
        break;
      }
      case 1: {
        this.currentMonth = "Febrero";
        break;
      }
      case 2: {
        this.currentMonth = "Marzo";
        break;
      }
      case 3: {
        this.currentMonth = "Abril";
        break;
      }
      case 4: {
        this.currentMonth = "Mayo";
        break;
      }
      case 5: {
        this.currentMonth = "Junio";
        break;
      }
      case 6: {
        this.currentMonth = "Julio";
        break;
      }
      case 7: {
        this.currentMonth = "Agosto";
        break;
      }
      case 8: {
        this.currentMonth = "Septiembre";
        break;
      }
      case 9: {
        this.currentMonth = "Octubre";
        break;
      }
      case 10: {
        this.currentMonth = "Noviembre";
        break;
      }
      case 11: {
        this.currentMonth = "Diciembre";
        break;
      }
    }
  }

  sign() {
    const student = {
      studentId: this.studentId,
      controlNumber: this.controlNumber,
      fullName: this.nameStudent,
      career: this.career
    };

    Swal.fire({
      title: 'Atención',
      text: 'Estas seguro/a de firmar la documentación?',
      type: 'warning',
      showCancelButton: true,
      cancelButtonColor: '#d33',
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Firmar',
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((res) => {
      if (res.value) {
        this.contractProv.sign(student).subscribe((res) => {
          console.log(res);
          if(res.created){
            this.onClose();
          }
        });
      }
    });
  }

}

